import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styletron-react';
import { FlexContainer } from '../../components/layout/FlexContainer';
import { staticColors } from '../../const/colors/staticColors';
import { useIsInputFocused } from '../../hooks/useIsInputFocused';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { InputBase } from './InputBase/InputBase';
import { useNormalInputBaseStyle, useNormalInputWrapperStyle, } from './useInputStyles';
import { useIsErrorTestAttribute } from './useIsErrorTestAttribute';
const noAppearanceStyle = {
    appearance: 'none',
    WebkitAppearance: 'none',
};
export const StyledInput = styled('input', (p) => ({
    ...p.$style,
    '::placeholder': {
        color: staticColors.inputPlaceholder,
        opacity: 1,
    },
    ':disabled::-webkit-inner-spin-button': noAppearanceStyle,
    ':read-only::-webkit-inner-spin-button': noAppearanceStyle,
}));
const StyledWrapper = styled('div', (p) => p.$style);
/**
 * Base for text and number input
 */
export const NormalInputBase = forwardRef(({ label, caption, disabled, error = false, updated = false, warning = false, readOnly = false, isRequiredLabel = false, gapRight = false, testId, tooltip, tooltipTabIndex, beforeElement, afterElement, onFocus, onBlur, min, max, isLink, inputWrapperRef, captionColorOverride, ...rest }, ref) => {
    const { isFocused, handleBlur, handleFocus } = useIsInputFocused({
        disabled,
        readOnly,
        onBlur,
        onFocus,
    });
    const isErrorTestAttribute = useIsErrorTestAttribute(!!error);
    const testIdAttribute = useTestIdAttribute(testId);
    const inputStyle = useNormalInputBaseStyle({ readOnly, isLink, warning });
    const wrapperStyle = useNormalInputWrapperStyle({
        isFocused,
        readOnly,
        isLink,
        warning,
    });
    return (_jsx(InputBase, { label: label, isRequiredLabel: isRequiredLabel, caption: caption, captionColorOverride: captionColorOverride, tooltip: tooltip, tooltipTabIndex: tooltipTabIndex, error: error, updated: updated, warning: warning, gapRight: gapRight, isFocused: isFocused, testId: testId, children: _jsx(StyledWrapper, { ref: inputWrapperRef, $style: wrapperStyle, children: _jsxs(FlexContainer, { horizontalAlign: 'spaceBetween', verticalAlign: 'center', children: [beforeElement, _jsx(StyledInput, { ref: ref, $style: inputStyle, disabled: disabled, readOnly: readOnly, min: min, max: max, onFocus: handleFocus, onBlur: handleBlur, ...rest, ...testIdAttribute, ...isErrorTestAttribute }), afterElement] }) }) }));
});
